import './css/index.css';
import 'components/download-button/css/defaults.css';
import 'components/breadcrumbs';
import 'components/article-body';
import 'components/data-detail-share';
import 'components/group-cards-data';
import 'components/blockquote';
import 'components/footer';
import 'components/notification';

// import last
import 'components/snippets/callouts';
import 'components/snippets/images';
import 'components/snippets/footnotes';

import Mediator from 'js/mediator';
import Navigation from 'components/navigation';

Mediator.create( {

    componentClasses: [
        Navigation,
        {
            name: 'chart-line',
            module: () => import(
                /* webpackChunkName: 'chart-line' */
                'components/chart-line'
            )
        },
        {
            name: 'chart-line-partisan',
            module: () => import(
                /* webpackChunkName: 'chart-line-partisan' */
                'components/chart-line-partisan'
            )
        },
        {
            name: 'chart-line-with-range',
            module: () => import(
                'components/chart-line-with-range'
            )
        },
        {
            name: 'chart-select',
            module: () => import(
                'components/chart-select'
            )
        },
        {
            name: 'chart-series',
            module: () => import(
                /* webpackChunkName: 'chart-series' */
                'components/chart-series'
            )
        }

    ],

    init() {

        console.info( 'The Data - Data Detail Page has initiated.' );

    },

    ready() {

        console.info( 'The Data - Data Detail Page is ready.' );

        console.info( 'Components:', this.components );

    }

} );
